export const redPorkCurry = {
  id: "redPorkCurry",
  link: "/#/recipes/recipes/redPorkCurry",
  name: "Red Pork Curry",
  cuisine: "Alethi Men's Food",
  summary: "Pork chunks in a very spicy red curry",
  inspiration: "Rogan Josh",
  quantity: "6 servings",
  time: "1 hour",
  notes:
    "This is the spiciest recipe in the collection. On a scale of 1 to 10, it's a 9. It's possible to get spicier, but not by much. This is based off the spicy pork curry that Adolin gives Shallan when he's talking about the changing gender roles. If you want to make it less spicy, you could try replacing some of the gochugaru with paprika. Take the amount of gochugaru you remove, then use 3/4 of that amount of paprika.",
  quotes:
    'Adolin... picked out a few chunks of pork from a creamy red curry, then put them on a plate and handed them in her direction... "It would burn my lips off, Adolin Kholin," Shallan said. "Don\'t think I didn\'t notice you picking the absolute spiciest concoction Palona sent." (Oathbringer, ch 13)',
  image:
    "https://jozomby-public.s3.amazonaws.com/recipes/pork-curry-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "yogurt",
          display: "1 cup plain yogurt"
        },
        {
          item: "gochugaru",
          display: "1 cup gochugaru"
        },
        {
          item: "pork",
          display: "2 1/2 lbs pork loin"
        },
        {
          item: "vegetableOil",
          display: "1/2 cup vegetable oil"
        },
        {
          item: "fennelSeeds",
          display: "1 tsp fennel seeds"
        },
        {
          item: "ginger",
          display: "1 tsp ground ginger"
        },
        {
          item: "cumin",
          display: "1 tsp ground cumin"
        },
        {
          item: "cloves",
          display: "1/2 tsp ground cloves"
        },
        {
          item: "cardamom",
          display: "1/2 tsp ground cardamom"
        },
        {
          item: "cinnamon",
          display: "1/2 tsp ground cinnamon"
        },
        {
          item: "garamMasala",
          display: "2 tsp garam masala"
        },
        {
          item: "salt",
          display: "1 tsp salt"
        },
        {
          item: "bayLeaves",
          display: "3 whole bay leaves"
        },
        {
          item: "mustardSeed",
          display: "1/2 tsp ground mustard seed"
        },
        {
          item: "turmeric",
          display: "1/2 tsp turmeric"
        },
        {
          item: "water",
          display: "6 cups water, plus extra, divided"
        },
        {
          item: "rice",
          display: "2 cups basmati rice, optional"
        },
        {
          item: "lavisFlatbreadPocket",
          display: (
            <>
              1 recipe{" "}
              <a href="/#/recipes/recipes/lavisFlatbreadPocket">
                lavis flatbread pockets
              </a>{" "}
              -OR- other flatbread, such as corn tortillas. Optional
            </>
          )
        }
      ]
    }
  ],
  steps: [
    "In a bowl, combine the yogurt and gochugaru. Set aside. Chop the pork into cubes around 3/4 inches in size. Set aside.",
    "Heat the vegetable oil in a large frying pan over high heat until it hits the smoke point. Add the fennel seeds, ginger, cumin, cloves, cardamom, cinnamon, garam masala, salt, bay leaves, mustard powder, and turmeric. Stir and fry for 30 seconds. Add the pork and cook and stir until cooked, about 2 minutes.",
    "Add the gochugaru paste and 2 cups of the water. Stir to combine. Lower heat to medium-low and simmer for 45 minutes. Stir occasionally, and each time the curry gets very thick, add 1/2 cup of water. You will likely add water three times or so. At the end, there will be pork chunks coated in a thick sauce.",
    "Meanwhile, prepare the basmati rice and/or flatbread. Cook the rice as directed by your rice cooker, using the water-to-rice ratio printed on your bag of rice.",
    "Serve curry with rice, or stuffed into flatbread pockets."
  ]
}
